var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoutSwitchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.55664 0.942383C9.55664 0.528169 9.22085 0.192383 8.80664 0.192383C8.39243 0.192383 8.05664 0.528169 8.05664 0.942383V8.94238C8.05664 9.3566 8.39243 9.69238 8.80664 9.69238C9.22085 9.69238 9.55664 9.3566 9.55664 8.94238V0.942383ZM4.29051 3.51543C4.60699 3.2482 4.64691 2.77501 4.37968 2.45853C4.11244 2.14205 3.63925 2.10213 3.32277 2.36936C1.99171 3.49331 1.03815 4.99911 0.591175 6.68291C0.144199 8.36671 0.225396 10.1472 0.823774 11.7833C1.42215 13.4194 2.50881 14.8322 3.93664 15.8303C5.36448 16.8285 7.06452 17.3638 8.80664 17.3638C10.5488 17.3638 12.2488 16.8285 13.6766 15.8303C15.1045 14.8322 16.1911 13.4194 16.7895 11.7833C17.3879 10.1472 17.4691 8.36671 17.0221 6.68291C16.5751 4.99911 15.6216 3.49331 14.2905 2.36936C13.974 2.10213 13.5008 2.14205 13.2336 2.45853C12.9664 2.77501 13.0063 3.2482 13.3228 3.51543C14.4189 4.44104 15.2042 5.6811 15.5723 7.06776C15.9404 8.45442 15.8736 9.9207 15.3808 11.2681C14.888 12.6155 13.9931 13.7789 12.8172 14.6009C11.6414 15.4229 10.2413 15.8638 8.80664 15.8638C7.37196 15.8638 5.97192 15.4229 4.79606 14.6009C3.62019 13.7789 2.7253 12.6155 2.23252 11.2681C1.73973 9.9207 1.67287 8.45442 2.04096 7.06776C2.40906 5.68111 3.19435 4.44104 4.29051 3.51543Z",
    fill: "#FF4033"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoutSwitchIcon);
export default __webpack_public_path__ + "static/media/logout-switch-icon.dac74a2cb9669291f3d49639a211f037.svg";
export { ForwardRef as ReactComponent };